export const socialProjectBookingExportColumns = [
	{ label: 'Sr No', key: 'index' },
	{
		label: 'Community',
		render: b => b?.hub?.name || '',
	},
	{
		label: 'Sanstha',
		render: b => b?.sansthaId?.name || '',
	},
	{
		label: 'User Name',
		render: b => (b?.userId ? `${b.userId.firstName || ''} ${b.userId.lastName || ''}`.trim() : ''),
	},
	{
		label: 'User Mobile',
		render: b => b?.userId?.mobile || '',
	},
	{
		label: 'Social Project',
		render: b => b?.project?.title || '',
	},
	{
		label: 'Payment Type',
		render: b => (b?.isOffline ? 'Offline' : 'Online'),
	},
	{
		label: 'Amount',
		render: b => b?.amount ?? '',
	},
	{
		label: 'Payment Mode',
		render: b => b?.paymentMode || '',
	},
	{
		label: 'Payment Reference No',
		render: b => b?.paymentRef || '',
	},
	{
		label: 'Payment Date',
		render: b => (b?.paymentDate ? new Date(b.paymentDate).toLocaleDateString('en-IN') : ''),
	},
	{
		label: 'Status',
		render: b => b?.status || '',
	},
]
